/* eslint-disable no-param-reassign */
import axios from 'axios'
import { API_URL } from 'services/config'

const isApiRequest = (config) => {
    const url = config.url || ''
    return url.startsWith(API_URL) || url.startsWith('/api')
}

axios.interceptors.request.use(
    (config) => {
        if (isApiRequest(config) && config.params?.referer !== 'web') {
            config.params = { ...config.params, referer: 'web' }
        }

        return config
    },
    (error) => Promise.reject(error)
)

const axiosInterceptors = (authStore) => {
    // Handles all 503 requests
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error?.response?.status === 503) {
                authStore.setApiOffline()
            }

            return Promise.reject(error)
        }
    )

    // Handles all 403 requests
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response !== undefined && error.response?.status > 403) {
                error.response.unknown = true
            }

            return Promise.reject(error)
        }
    )

    // Handles all 401 requests
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response?.status === 401 && authStore.isAuthenticated) {
                authStore.logout()
            }

            return Promise.reject(error)
        }
    )

    // Adds bearer to all API requests
    axios.interceptors.request.use(
        (config) => {
            if (authStore.isAuthenticated) {
                config.headers.Authorization = `Bearer ${authStore.accessToken}`
            }

            return config
        },
        (error) => Promise.reject(error)
    )

    // Token update
    axios.interceptors.response.use(
        (response) => {
            if (
                response &&
                response.data &&
                response.data?.metadata &&
                response.data?.metadata?.token
            ) {
                // updates jwtoken if needed
                authStore.updateToken(response.data?.metadata?.token?.token)
            }

            return response
        },
        (error) => Promise.reject(error)
    )
}

export default axiosInterceptors
